// Spustenie kontroly časového limitu každých 30 sekúnd a po refreshnutí stránky
check_cart_time_limit();

setInterval(check_cart_time_limit, 30000); // 30000 ms = 30 sekúnd
function check_cart_time_limit() {

    let is_checkout = 0;
    if (typeof wc_checkout_params !== 'undefined'){
        is_checkout = 1;
    }

    if( !$('body.cart-page').length && !is_checkout && !$('.basket_wrapper').hasClass('has_minicart')){
        return false;
    }

    jQuery.ajax({
        url: BASE_URL+'/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
            action: 'check_cart_items_time_limit',
            is_checkout : is_checkout,
            // is_ajax: true
        },
        success: function(response) {

            response = JSON.parse( response );

            if(response.notify){
                notif('warning', response.notif_text);
            }

            if(response.prolong){
                notif('success', response.prolong_text);
                reinit_time_countdown(true);
            }

            if(response.deleted){

                refresh_header(response.header);
                notif('danger', response.deleted_notif);

                if($('.continue-to-checkout').length){
                    // is cart page
                    $('.continue-to-checkout').remove();
                    notif('danger', response.redirect_notif);
                    setTimeout(function(){
                        location.reload();
                    }, 4000);
                }else{
                    // setTimeout(function(){
                    //     //location.reload();
                    // }, 3000);
                }

            }
        },
        error: function(error) {
            console.error(error);
        }
    });
}

function refresh_header(header){

    update_mini_cart_count(header);

    /* let mini-cart reinit */
    update_mini_cart_content(false, header, true);
    mini_cart_init = false;

    let reservation_timer = $('.js-reservation-timer-wrapper', header);
    $('.js-reservation-timer-wrapper').replaceWith(reservation_timer);

    reinit_time_countdown();
}


function on_remove_from_cart(remove_button){
    let cart_key = remove_button.data('cart-key');

    let data_to_send = {
        action: 'remove_service_from_cart',
        cart_key: cart_key,
        is_ajax: true
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {

        response = JSON.parse( response );

        if(response){
            if(response.success){

                refresh_header(response.header);

                if($('.js-event-choose-day.active').length){

                    if($('.js-event-repeating-term:checked').length){
                        let term_id = $('.js-event-repeating-term:checked').data('term-id');
                        $('.js-selected-repeating_term_id').val(term_id);
                    }
                    $('.js-event-choose-day.active').click();
                }else if($('.js-choose-day.active').length){
                    $('.js-choose-day.active').click();
                }else{
                    /* reinit table */
                    let term_type = $('.js-select-term.active').data('term');
                    if (typeof term_type  !== 'undefined'){

                        let results = new RegExp('[?&]' + 'week' + '=([^&#]*)').exec(window.location.href);
                        let week = results ? decodeURIComponent(results[1]) : null;

                        if(!week){
                            week = 0;
                        }
                        get_table_calendar_html(term_type, week); // reinit table
                    }

                    let reservations_list = $('.js-reservation-list');
                    if(reservations_list.length){
                        // refresh reservation list buttons in my account/reservations
                        refresh_reservation_list_add_to_cart_buttons();
                    }

                    let add_to_cart_event_button = $('.js-add-ticket-interval-payment-to-cart');
                    if(add_to_cart_event_button.length){
                        add_to_cart_event_button.text(add_to_cart_event_button.data('default-text'));
                    }
                }
            }
        }
    })
}
